module.exports = __webpack_public_path__ + "img/PDM-600-Mobile-Trafo1.fd40d7d6.png";